import React, { Component } from 'react';
import { Provider } from 'react-redux';
import './App.css';
import logo from '../public/images/logoblackwhite72dpi-transparent.png';
import Today from './containers/Today';
import LockedFees from './containers/LockedFees';
import RegistrationFees from './sections/RegistrationFees';
import TitleFees from './sections/TitleFees';
import SalesTaxes from './sections/SalesTaxes';
import FeeCalculatorTotal from './sections/FeeCalculatorTotal';
import ResetButton from './containers/ResetButton';
import ResetSection from './containers/ResetSection';
import store from './redux/store';

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <div className="Wrapper container">

          <div className="FormContent">
            <div className="Header">
              <div className="Header-left">
                <img className="Header-logo" src={logo} alt="Logo" />
              </div>

              <div className="Header-right">
                <h1 className="Section-header Section-header--long">Fee Calculator</h1>
                <ResetButton />
                <LockedFees />
              </div>
            </div>

            <div className="Section">
              <h1 className="Section-header">Registration Fees</h1>
              <ResetSection section="Registration" />
              <Today />
              <RegistrationFees />
            </div>

            <div className="Section">
              <h1 className="Section-header">Title Fees</h1>
              <ResetSection section="Title" />
              <TitleFees />
            </div>

            <div className="Section">
              <h1 className="Section-header">Sales Taxes</h1>
              <ResetSection section="Sales" />
              <SalesTaxes />
            </div>

            <div className="Section TotalSection">
              <FeeCalculatorTotal />
            </div>

            <div className="Section Footer">
              <p>Calculations based off of the Fee Calculator PDF developed by John Archer (in partnership with the Hillsborough County Tax Collector Office).
              Designed and Developed for the web by <b>David Brierton</b> in the Manatee County Tax Collector Office. <b>Last updated</b> April 29, 2017.
              All Fees and Totals contained herein are <em>estimations only</em> and are subject to change.</p>
            </div>

          </div>
        </div>

      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js